var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAutist(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1583_13145)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0728 5.05136C10.0728 5.05136 9.90876 6.55058 10.2599 7.19122C11.9255 10.2313 14.3451 13.4699 17.0005 15.9949C16.3313 16.9821 15.6352 17.9465 14.8978 18.8842C13.7622 17.5218 12.7579 16.0506 11.8177 14.5489C11.0836 13.3768 10.3871 12.1795 9.73525 10.9601C9.36883 10.2749 8.81362 9.47197 8.71447 8.73575C8.55791 7.57148 10.0732 5.05054 10.0732 5.05054L10.0728 5.05136Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.162 5.22314C14.1587 5.22438 14.1797 6.60701 13.8563 7.18667C12.1022 10.3293 9.71244 13.661 7 16.2767C7.74565 17.2251 8.52848 18.134 9.36874 19C10.4746 17.5955 11.4578 16.095 12.3794 14.5653C13.0925 13.3821 13.7699 12.1771 14.4057 10.951C14.7635 10.2613 15.2935 9.46701 15.4009 8.72338C15.5616 7.60937 14.162 5.22314 14.162 5.22314Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0242 4C15.5806 4 15.4009 8.72342 15.4009 8.72342C15.4009 8.72342 14.7156 6.21607 12.0626 6.21607C9.14117 6.21607 8.70535 8.5714 8.70535 8.5714C8.69213 8.56934 8.69502 4 12.0242 4Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0241 4.11041C14.5903 4.11041 15.2173 6.55308 15.3673 7.9254C15.2396 6.57821 14.6518 4 12.0241 4C9.3963 4 8.84522 6.82499 8.7312 8.03334C8.86918 6.77225 9.47437 4.11041 12.0241 4.11041Z",
    fill: "url(#paint0_linear_1583_13145)",
    fillOpacity: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1583_13145",
    x1: 9.80238,
    y1: 6.02326,
    x2: 12.8279,
    y2: 5.98847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#52595D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1583_13145"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 15,
    fill: "white",
    transform: "translate(7 4)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutist);
export default __webpack_public_path__ + "static/media/autist.7a4518657afe3ace59f187fa9c58bce2.svg";
export { ForwardRef as ReactComponent };